module.exports = __webpack_public_path__ + "static/img/partner_Luana.72c5efb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/timemaria/partner_Luana.jpg
// module id = Ciwz
// module chunks = 1